import { ArticleList } from 'ui/components/3-organisms/ArticleList/ArticleList';
import { ArticlesFetcher } from './ArticlesFetcher';

export const ArticleListFeature: React.FC<Content.ArticleList> = ({ content }) => (
	<ArticleList
		{...content?.properties}
		bgColor={content?.properties.color}
		rootFolderId={content?.properties.rootFolder.id}
		articleFetcher={ArticlesFetcher}
	/>
);
